export default __webpack_public_path__ + "static/media/icons.5a590744.svg";